/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "elevator-484a9601--sprite",
  "use": "elevator-484a9601--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"elevator-484a9601--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(1.818 1.817)\"><path d=\"M31.167,0H1.2A1.169,1.169,0,0,0,0,1.2v29.97a1.2,1.2,0,0,0,1.2,1.2h29.97a1.2,1.2,0,0,0,1.2-1.2V1.2A1.169,1.169,0,0,0,31.167,0Zm-2.48,14.835a1.441,1.441,0,0,1-.727.214,1.337,1.337,0,0,1-1.069-.556L25.1,11.8l-1.8,2.693a1.293,1.293,0,1,1-2.138-1.454l2.864-4.275a1.306,1.306,0,0,1,2.138,0l2.864,4.275A1.3,1.3,0,0,1,28.687,14.835Zm-7.14,2.693a1.344,1.344,0,0,1,1.8.342l1.8,2.693,1.8-2.693a1.293,1.293,0,0,1,2.138,1.454L26.207,23.6a1.306,1.306,0,0,1-2.138,0l-2.864-4.275A1.3,1.3,0,0,1,21.547,17.529ZM2.394,2.394H17.785V30.012H2.394V2.394Z\" fill=\"currentColor\" /><circle cx=\"2.522\" cy=\"2.522\" r=\"2.522\" transform=\"translate(6.686 7.987) rotate(-67.5)\" fill=\"currentColor\" /><path d=\"M19.656,24.925A9.4,9.4,0,0,0,18.374,23.6a1.129,1.129,0,0,0-.812-.3h-3.8a1.129,1.129,0,0,0-.812.3,9.4,9.4,0,0,0-1.283,1.325,9.933,9.933,0,0,0-1.967,6.413,1.2,1.2,0,0,0,1.24,1.2h.043a1.215,1.215,0,0,0,1.2-1.283,7.786,7.786,0,0,1,.641-3.463,42.409,42.409,0,0,1-.128,4.66l-.086.812V41.3a1.24,1.24,0,1,0,2.48,0V34.587h1.069V41.3a1.24,1.24,0,1,0,2.48,0v-8.08L18.5,30.482c-.043-.855-.043-1.753-.043-2.608a7.854,7.854,0,0,1,.6,3.377,1.242,1.242,0,0,0,1.2,1.283H20.3a1.232,1.232,0,0,0,1.24-1.2A9.385,9.385,0,0,0,19.656,24.925Z\" transform=\"translate(-5.548 -13.339)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
